<template>
  <div class="items main-content">
    <div class="page-header">
      <div class="d-flex flex-row">
        <div>
          <h3 class="page-title">
            {{ $tc("communications.communication", 2) }}
          </h3>
        </div>
      </div>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">
            {{ $t("general.home") }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $tc("communications.communication", 2) }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <!-- <div class="col-xs-2 mr-4">
            <base-button
                v-show="totalCommunications || filtersApplied"
                :outline="true"
                :icon="filterIcon"
                color="theme"
                size="large"
                right-icon
                @click="toggleFilter"
            >
                {{ $t('general.filter') }}
            </base-button>
            </div> -->
        <router-link
          slot="item-title"
          class="col-xs-2"
          to="communications/create"
        >
          <base-button color="theme" icon="plus" size="large">
            {{ $t("communications.add_communication") }}
          </base-button>
        </router-link>
      </div>
    </div>

    <!-- <transition name="fade">
      <div v-show="showFilters" class="filter-section">
        <div class="row">
          <div class="col-sm-3">
            <label class="form-label"> {{ $tc('items.name') }} </label>
            <base-input
              v-model="filters.name"
              type="text"
              name="name"
              autocomplete="off"
            />
          </div>
          <div class="col-sm-3">
            <label class="form-label"> {{ $tc('items.part_number') }} </label>
            <base-input
              v-model="filters.part_number"
              type="text"
              name="part_number"
              autocomplete="off"
            />
          </div>
          <div class="col-sm-3">
            <label class="form-label"> {{ $tc('items.unit') }} </label>
            <base-select
              v-model="filters.unit"
              :options="itemUnits"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('items.select_a_unit')"
              label="name"
              autocomplete="off"
            />
          </div>
          <div class="col-sm-3">
            <label class="form-label"> {{ $tc('items.price') }} </label>
            <base-input
              v-model="filters.price"
              type="text"
              name="name"
              autocomplete="off"
            />
          </div>
          <label class="clear-filter" @click="clearFilter"> {{ $t('general.clear_all') }}</label>
        </div>
      </div>
    </transition> -->

    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <satellite-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{
          $t("communications.no_communications")
        }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("communications.list_of_communications")
        }}</label>
      </div>
      <div class="btn-container">
        <base-button
          :outline="true"
          color="theme"
          class="mt-3"
          size="large"
          @click="$router.push('communications/create')"
        >
          {{ $t("communications.add_new_communication") }}
        </base-button>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ communications.length }}</b>
          {{ $t("general.of") }} <b>{{ totalCommunications }}</b>
        </p>
        <transition name="fade">
          <v-dropdown v-if="selectedCommunications.length" :show-arrow="false">
            <span
              slot="activator"
              href="#"
              class="table-actions-button dropdown-toggle"
            >
              {{ $t("general.actions") }}
            </span>
            <v-dropdown-item>
              <!-- <div class="dropdown-item" @click="removeMultipleItems">
                <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                {{ $t('general.delete') }}
              </div> -->
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllCommunications"
        />
        <label
          v-show="!isRequestOngoing"
          for="select-all"
          class="custom-control-label selectall"
        >
          <span class="select-all-label">{{ $t("general.select_all") }} </span>
        </label>
      </div>

      <table-component
        ref="table"
        :data="fetchData"
        :show-filter="false"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>
        <table-column :label="$t('general.to')" show="action_type" />
        <table-column :label="$t('communications.subject')" show="subject" />
        <table-column
          :label="$t('general.status')"
          sort-as="created_at"
          show="status"
        />
        <table-column
          :label="$t('communications.added_on')"
          sort-as="created_at"
          show="formattedCreatedAt"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t("communications.action") }} </span>
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <router-link
                  :to="{ path: `communications/${row.id}/edit` }"
                  class="dropdown-item"
                >
                  <font-awesome-icon
                    :icon="['fas', 'pencil-alt']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.edit") }}
                </router-link>
              </v-dropdown-item>
              <v-dropdown-item v-if="row.status == 'Disable'">
                <div class="dropdown-item" @click="changeStatus(row.id)">
                  <font-awesome-icon
                    :icon="['fas', 'toggle-on']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.enable") }}
                </div>
              </v-dropdown-item>
              <v-dropdown-item v-if="row.status == 'Enable'">
                <div class="dropdown-item" @click="changeStatus(row.id)">
                  <font-awesome-icon
                    :icon="['fas', 'toggle-off']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.disable") }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DotIcon from "../../components/icon/DotIcon";
import SatelliteIcon from "../../components/icon/SatelliteIcon";
import BaseButton from "../../../js/components/base/BaseButton";

export default {
  components: {
    DotIcon,
    SatelliteIcon,
    BaseButton
  },
  data() {
    return {
      id: null,
      showFilters: false,
      sortedBy: "created_at",
      isRequestOngoing: true,
      filtersApplied: false,
      filters: {
        name: "",
        part_number: "",
        unit: "",
        price: ""
      }
    };
  },
  computed: {
    ...mapGetters("communication", [
      "communications",
      "selectedCommunications",
      "totalCommunications",
      "selectAllField"
    ]),

    ...mapGetters("currency", ["defaultCurrency"]),
    showEmptyScreen() {
      return (
        !this.totalCommunications &&
        !this.isRequestOngoing &&
        !this.filtersApplied
      );
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    selectField: {
      get: function() {
        return this.selectedCommunications;
      },
      set: function(val) {
        this.selectCommunication(val);
      }
    },
    selectAllFieldStatus: {
      get: function() {
        return this.selectAllField;
      },
      set: function(val) {
        this.setSelectAllState(val);
      }
    }
  },
  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    }
  },

  destroyed() {
    if (this.selectAllField) {
      this.selectAllCommunications();
    }
  },
  methods: {
    ...mapActions("communication", [
      "fetchCommunications",
      "selectAllCommunications",
      "selectCommunication",
      "setSelectAllState",
      "changeStatusCommunication"
    ]),
    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData({ page, per_page, filter, sort }) {
      let data = {
        orderByField: sort.fieldName || "created_at",
        orderBy: sort.order || "desc",
        per_page, // Add rowsPerPage in the API request
        page
      };

      this.isRequestOngoing = true;
      let response = await this.fetchCommunications(data);
      this.isRequestOngoing = false;

      return {
        data: response.data.communications.data,
        pagination: {
          totalPages: response.data.communications.last_page,
          currentPage: page,
          rowsPerPage: response.data.communications.per_page // Add rowsPerPage in the API request
        }
      };
    },
    setFilters() {
      this.filtersApplied = true;
      this.refreshTable();
    },
    clearFilter() {
      this.filters = {
        name: "",
        part_number: "",
        unit: "",
        price: ""
      };

      this.$nextTick(() => {
        this.filtersApplied = false;
      });
    },
    toggleFilter() {
      if (this.showFilters && this.filtersApplied) {
        this.clearFilter();
        this.refreshTable();
      }

      this.showFilters = !this.showFilters;
    },
    async changeStatus(id) {
      let response = await this.changeStatusCommunication(id);
      if (response.data.success == true) {
        window.toastr["success"](
          this.$t("communications.status_updated_message")
        );
        this.refreshTable();
      } else if (response.data.error) {
        window.toastr["error"](response.data.error);
      }
    }
  }
};
</script>
